import {http, onSuccess, onFail} from "./http";

// Member suggestion
export const getMemberSuggestions = ({eventKey, params}) => {
    return http.get(`/api/cp/event/${eventKey}/autocomplete/members`, {params})
        .then(onSuccess, onFail);
};
